import { merge, get } from 'lodash'
import { getDateCellEditor, getNumericCellEditor } from '@/lib/formatting.utils'
import store from '@/store/index'

export class LmGridOptions {
  constructor(params, noResize, infiniteScrollRequest, updateRowsCount) {
    if (!params) {
      return
    }
    // alphabetically sort
    get(params, 'context.sortColumn')
      ? (params.columnDefs[params.context.sortColumn].sort = get(params, 'context.sortOrder')
          ? get(params, 'context.sortOrder')
          : 'asc')
      : (params.columnDefs[0].sort = get(params, 'context.sortOrder') ? get(params, 'context.sortOrder') : 'asc')
    params.columnDefs[0].sort = get(params, 'context.disableAutoSort') ? false : params.columnDefs[0].sort
    params.columnDefs.forEach(col => {
      this.setHeaderTooltip(col)
      col.cellClass = this.getCellClasses(col)
      if (col.hasOwnProperty('children')) {
        col.children.forEach(child => {
          child.cellClass = this.getCellClasses(child)
          this.setHeaderTooltip(child)
        })
      }
    })
    return merge(
      {
        defaultColDef: {
          resizable: true,
          sortable: true,
          filter: true,
          floatingFilterComponentParams: {
            suppressFilterButton: true
          }
        },
        rowHeight: 36,
        suppressContextMenu: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        enableCellChangeFlash: false,
        animateRows: true,
        sortingOrder: ['asc', 'desc'],
        suppressColumnVirtualisation: true,
        domLayout: 'autoHeight',
        immutableData: false, // this needs to stay disabled
        pagination: params.rowData ? params.rowData.length > 25 : false,
        suppressPaginationPanel: true,
        paginationPageSize: 500,
        icons: {
          groupContracted: '<i class="fas fa-chevron-right q-pl-lg q-pr-lg row-group-top-sm"></i>',
          groupExpanded: '<i class="fas fa-chevron-down q-pl-lg q-pr-lg row-group-top-sm"></i>'
        },
        components: {
          dateCellEditor: getDateCellEditor(store.state.settings.date_format),
          numericCellEditor: getNumericCellEditor(
            store.state.settings.locale,
            store.state.settings.decimal_separator,
            store.state.settings.thousand_separator
          )
        },
        getRowClass: params => {
          return params.node.context.classes ? params.node.context.classes.join(' ') : ''
        },
        getRowNodeId: data => {
          return data.id
        },
        onGridReady: params => {
          const updateData = () => {
            let datasource = new ServerSideDatasource(infiniteScrollRequest, updateRowsCount)
            params.api.setServerSideDatasource(datasource)
          }

          infiniteScrollRequest && updateData()
          !noResize && params.api.sizeColumnsToFit()
          params.api.resetRowHeights()
        },
        onFirstDataRendered: params => {
          !noResize && params.api.sizeColumnsToFit()
          params.api.resetRowHeights()
        },
        onColumnVisible: params => {
          !noResize && params.api.sizeColumnsToFit()
        },
        onColumnResized: event => {
          if (event.finished) {
            event.api.resetRowHeights()
          }
        }
      },
      { ...params }
    )
  }

  setHeaderTooltip(col) {
    col.headerTooltip = col.headerName
  }

  getCellClasses(colDef) {
    if (typeof colDef.editable === 'function') return
    let editableClass = colDef.editable ? 'lm-editable' : ''
    let customClass = get(colDef, 'cellClass', '')

    return editableClass.concat(` ${customClass}`)
  }
}

function ServerSideDatasource(apiRequest, updateRowsCount) {
  return {
    getRows(params) {
      apiRequest(params.request).then(response => {
        if (!response) return
        const { data } = response
        params.success({ rowData: data.result.data, rowCount: data.result.last_row })
        updateRowsCount(data.result.last_row)
        if (!data.result.last_row) params.parentNode.gridApi.showNoRowsOverlay()
        else params.parentNode.gridApi.hideOverlay()
      })
    }
  }
}
